import { render, staticRenderFns } from "./CardInformativa.vue?vue&type=template&id=43e89b99&scoped=true&"
import script from "./CardInformativa.vue?vue&type=script&lang=ts&"
export * from "./CardInformativa.vue?vue&type=script&lang=ts&"
import style0 from "./CardInformativa.vue?vue&type=style&index=0&id=43e89b99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e89b99",
  null
  
)

export default component.exports